import { useI18nContext } from '@/core/providers/I18nProvider';
import LoginSvg from '@assets/images/svg/login.svg';
import React from 'react';
import { View } from 'react-native';

export interface LoginIconProps {
    size?: number;
    color?: string;
}

export function LoginIcon({ size = 32, color = '#333333' }: LoginIconProps) {
    const { isRTL } = useI18nContext();
    
    return (
        <View style={{ transform: [{ scaleX: isRTL ? -1 : 1 }] }}>
            <LoginSvg width={size} height={size} color={color} />
        </View>
    );
}

export default LoginIcon;